import { render, staticRenderFns } from "./PerfilUsuario.vue?vue&type=template&id=f406a7e8&scoped=true&"
import script from "./PerfilUsuario.vue?vue&type=script&lang=js&"
export * from "./PerfilUsuario.vue?vue&type=script&lang=js&"
import style0 from "./PerfilUsuario.vue?vue&type=style&index=0&id=f406a7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f406a7e8",
  null
  
)

export default component.exports